import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../../Confg/UserContext';
import useStoreBlock from '../../hooks/useStoreBlock';

/**
 * Barra a entrada nas FUNÇÕES PRINCIPAIS quando a loja está bloqueada pelo suporte.
 *
 * Envolve as rotas operacionais (Chamar Entregador, Pedidos, Caixa, Cardápio…) e manda
 * a pessoa para a /Home, onde a tela de bloqueio explica o débito, o prazo e oferece o
 * pagamento. A Home NÃO é envolvida — ela é o único lugar que a loja bloqueada acessa.
 *
 * Isto é conveniência de navegação, não a proteção: quem edita o bundle passa daqui.
 * O que barra de verdade é o backend (assertMerchantNotBlocked), que recusa cotação,
 * alocação e despacho iFood da loja bloqueada.
 */
export default function BlockedGate({ children }) {
  const { user } = useUser();
  const { carregando, bloqueada } = useStoreBlock(user?.uid);

  // Enquanto não sabemos, não mostramos a tela protegida nem redirecionamos: um piscar da
  // tela operacional antes do redirect é justamente o que se quer evitar.
  if (carregando) return null;
  if (bloqueada) return <Navigate to="/Home" replace state={{ bloqueada: true }} />;
  return children;
}
